module.exports = __webpack_public_path__ + "static/media/hand-shake.4a807020.png";